import React from 'react';
// import React, { useEffect, useState } from 'react';
import { projectData } from './ProjectData';
import * as styles from "./ProjectGroup.module.css"
import { useStaticQuery, graphql, Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { nanoid } from 'nanoid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub } from '@fortawesome/free-brands-svg-icons'

const ProjectGroup = ({projectType}) => {
  const data = useStaticQuery(
    graphql`
      query{
        allFile {
          edges {
            node {
              name
              relativePath
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED,
                  formats: [AUTO, WEBP, PNG]
                )
              }
            }
          }
        }
      }
    `
  )

  let projects;
  switch (projectType) {
    case "desktop":
      projects = projectData.desktopProjects;
      break;
    case "mobile":
      projects = projectData.mobileProjects;
      break;
    case "web":
      projects = projectData.webProjects;
      break;
    default:
      break;
  }

  return (
    <section className={styles.projectGroup}>
      {projects.map(project => {
        const { title, info, internalUrl, externalUrl, repo, imagePath, containerWidth, id, language, stack, features } = project;
        const imageNode = data.allFile.edges.find((n) => n.node.relativePath.includes(imagePath)).node;
        const image = getImage(imageNode);
        const featureList = features.map(feature => 
          <li key={nanoid()} className={styles.feature}>{feature}</li>);

        return (
          <div key={id} className={styles.project}>
            <div className={styles.projectTextWrapper}>
              <h2 className={styles.projectTitle}>{title || 'Project Title'}</h2>
              <div>
                <p className={styles.descriptionText}>{info}</p>
                <p className={styles.descriptionText}>{`Language: ${language}`}</p>
                <p className={styles.descriptionText}>{`Stack: ${stack}`}</p>
                {features.length > 0 && <h3>Features:</h3>}
                <ul>{featureList}</ul>
              </div>
              <div className={styles.linkWrapper}>
                {internalUrl && <Link className={styles.link} to={internalUrl}>See Live</Link>}
                {externalUrl && (
                  <a
                  rel="noopener noreferrer"
                  className={styles.link}
                  href={externalUrl}
                  >
                    See Live
                  </a>
                )}
                {repo && (
                  <a
                    rel="noopener noreferrer"
                    className={styles.link}
                    href={repo}
                  >
                    <FontAwesomeIcon icon={faGithub} className={styles.icon}/>
                    Source Code
                  </a>
                )}
              </div>
            </div>
            <div className={styles.projectImageWrapper} style={{width: containerWidth}}>
                <GatsbyImage
                  image={image}
                  alt={`${title} thumbnail` }
                  className={styles.thumbnail}
                />
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default ProjectGroup;
